import type { IAssetMinimal } from "./asset.models.types";
import type { IUserMinimal } from "./user.models.types";

export enum CarouselItemStatus {
  DRAFT = "draft",
  LIVE = "live",
  ARCHIVED = "archived",
}

export enum CarouselActionType {
  LINK = "link",
  NAVIGATION = "navigation",
}

export enum NavigationTarget {
  CAMPAIGN_SCREEN = "campaign-screen",
  PAYOUTS_SCREEN = "payouts-screen",
  REFER_AND_EARN_SCREEN = "refer-and-earn-screen",
}

export interface ICarouselNavigation {
  target: NavigationTarget;
  extras: Record<string, any> | null;
}

export interface ICarouselAction {
  type: CarouselActionType;
  url: string | null;
  navigation: ICarouselNavigation | null;
}

export interface ICarouselStatusEntry {
  status: CarouselItemStatus;
  timestamp: string;
  user: IUserMinimal;
}

export interface ICarouselItem {
  id: string;
  action: ICarouselAction;
  asset: IAssetMinimal;
  status: ICarouselStatusEntry;
  statusLog: ICarouselStatusEntry[];
  createdAt: string;
  updatedAt: string;
}

export interface ICarouselOrderedItem extends ICarouselItem {
  order: number;
}
